import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const apiUrl = environment.apiUrl + 'guest';

@Injectable({
  providedIn: 'root',
})
export class BankService {
  constructor(private http: HttpClient) {}

  beautyBookBankAccounts: BehaviorSubject<any> = new BehaviorSubject(null);
  banks: BehaviorSubject<any> = new BehaviorSubject(null);

  private fetchBeautyBookBankAccounts() {
    return this.http
      .get(apiUrl + '/bank_accounts')
      .pipe(
        map((res: any) => {
          const bankAccounts = res.data;
          return bankAccounts;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getBeautyBookBankAccounts() {
    if (!this.beautyBookBankAccounts.value) {
      this.fetchBeautyBookBankAccounts().subscribe((data) => {
        this.beautyBookBankAccounts.next(data);
        return data;
      });
    }
    return this.beautyBookBankAccounts.asObservable();
  }

  private fetchBanks() {
    return this.http
      .get(apiUrl + '/banks')
      .pipe(
        map((res: any) => {
          const banks = res.data;
          return banks;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getBanks() {
    if (!this.banks.value) {
      this.fetchBanks().subscribe((data) => {
        this.banks.next(data);
        return data;
      });
    }
    return this.banks.asObservable();
  }
}
